import { useState, useEffect } from 'react';
import Hero from './components/Hero';
import Verticals from './components/Verticals';
import ValueAdd from './components/ValueAdd';
import Contact from './components/Contact';
import Footer from './components/Footer';
import FloatingPaws from './components/FloatingPaws';

export default function HomePage() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="relative min-h-screen overflow-hidden">
      {/* Gradient Background */}
      <div className="fixed inset-0 bg-gradient-to-b from-[#FFF5F0] via-[#F0FFF5] to-[#F5F0FF] -z-10" />
      
      {/* Floating Paw Prints */}
      <FloatingPaws />

      {/* Navigation */}
      <nav
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
          scrolled
            ? 'bg-white/80 backdrop-blur-xl shadow-lg'
            : 'bg-transparent'
        }`}
      >
        <div className="max-w-[1400px] mx-auto px-6 h-20 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img 
              src="https://static.readdy.ai/image/45ee86dea452076dc7a3c34b683d6864/c95ad8dc129089dbc87b5b9199c6fbcc.png" 
              alt="Bor Studio Logo" 
              className="h-10 w-10 object-contain"
            />
            <span className="text-2xl font-bold bg-gradient-to-r from-[#FF6B6B] to-[#6B5FFF] bg-clip-text text-transparent">
              Bor Studio
            </span>
          </div>
          <a
            href="#contact"
            className="px-6 py-2.5 border-2 border-transparent bg-gradient-to-r from-[#FF6B6B] to-[#6B5FFF] bg-clip-border rounded-full text-white font-medium hover:scale-105 transition-transform duration-300 whitespace-nowrap cursor-pointer"
            style={{
              borderImage: 'linear-gradient(to right, #FF6B6B, #6B5FFF) 1',
            }}
          >
            Get in Touch
          </a>
        </div>
      </nav>

      {/* Main Content */}
      <main>
        <Hero />
        <Verticals />
        <ValueAdd />
        <Contact />
      </main>

      <Footer />
    </div>
  );
}
